const header = {
  general: 'ЗАГАЛЬНІ ПОЛОЖЕННЯ',
  terms: 'ТЕРМІНИ',
  objectAgreement: 'ПРЕДМЕТ ДОГОВОРУ',
  legalNature: 'ПРАВОВА ПРИРОДА ПОСЛУГИ',
  acceptance: 'АКЦЕПТ ДОГОВОРУ',
  payment: 'ТАРИФИ, ОПЛАТА ТА БАЛАНС',
  refund: 'ПОВЕРНЕННЯ КОШТІВ',
  rightsAndResponsibilitySides: 'ПРАВА, ОБОВ’ЯЗКИ ТА БЕЗПЕКА',
  executor: 'ПРАВА ТА ОБОВ’ЯЗКИ АГРЕГАТОРА І ВИКОНАВЦЯ',
  liability: 'ВІДПОВІДАЛЬНІСТЬ',
  privacy: 'КОНФІДЕНЦІЙНІСТЬ І ПЕРСОНАЛЬНІ ДАНІ',
  other: 'СТРОК, ЗМІНИ ТА СПОРИ',
};

const introduction = [
  'Цей Договір є публічною офертою, договором приєднання та електронним договором. Він набирає чинності з дати публікації для всіх, хто ним користується.',
  'Цей Договір регулює взаємодію між Агрегатором, Користувачем, Виконавцем, Власником зарядної станції та Власником локації. Виконавець — особа, яка у відповідній зарядній сесії організовує та/або надає Користувачу Послугу заряджання під власним брендом або під брендом, доступним у Платформі, якщо інше не встановлено профілем станції. Одна й та сама особа може одночасно виконувати кілька ролей.',
  'Агрегатор — оператор платформи 220-km.com. Він дає доступ до сайту й застосунку, забезпечує запуск сесії та технічну інтеграцію з оплатою. Агрегатор не є надавачем Послуги заряджання, якщо сам не виступає Виконавцем на конкретній станції.',
  'Реєстрація, вхід, натискання «Оплатити», «Старт» чи аналогічної кнопки, сканування QR, початок зарядної сесії, оплата або подальше користування платформою означають, що Ви прийняли цей Договір повністю.',
];

export const companyInfo = {
  name: 'ТОВ «мережа 220»',
  fullName: 'ТОВАРИСТВО З ОБМЕЖЕНОЮ ВІДПОВІДАЛЬНІСТЮ «роумінгова мережа зарядних станцій 220 км»',
  shortName: 'мережа 220',
  edrpou: '45977567',
  address: '02160, Україна, місто Київ, проспект Соборності, будинок 17 офіс 2-92',
};

const body = [
  {
    id: 1,
    title: header.general,
    href: '#general',
    texts: [
      {
        id: '1.1',
        text: 'Цей Договір є публічним договором у розумінні ст. 633 Цивільного кодексу України, договором приєднання у розумінні ст. 634 ЦК України та публічною офертою у розумінні ст. 641 ЦК України. Він має юридичну силу відповідно до Закону України «Про електронну комерцію».',
      },
      {
        id: '1.2',
        text: 'Умови однакові для всіх Користувачів, крім випадків, коли тариф, мінімальна сума оплати чи інші умови прямо показані в застосунку, на сайті або на конкретній станції до початку сесії.',
      },
      {
        id: '1.3',
        text: 'Агрегатор може змінювати Договір, публікуючи нову редакцію на 220-km.com. Якщо інший строк не вказано, зміни діють з моменту публікації. Якщо Ви не згодні — припиніть користування. Подальше користування означає прийняття нової редакції.',
      },
    ],
  },
  {
    id: 2,
    title: header.terms,
    href: '#agreement',
    texts: [
      {
        id: '2.1',
        text: 'Платформа — сайт 220-km.com, мобільний застосунок та пов’язані сервіси, через які Користувач знаходить станції, оплачує та запускає зарядку.',
      },
      {
        id: '2.2',
        text: 'Користувач — фізична або юридична особа, яка користується Платформою чи зарядною станцією для заряджання електромобіля.',
      },
      {
        id: '2.3',
        text: 'Агрегатор — оператор Платформи 220-km.com, який забезпечує цифровий доступ, відображення станцій і тарифів, запуск сесії та технічну інтеграцію з банком / платіжним сервісом. Агрегатор не отримує оплату водія за Послугу заряджання, крім випадків, коли він сам є Виконавцем на цій станції, та крім своєї комісії за користування Платформою, якщо вона утримується окремо.',
      },
      {
        id: '2.4',
        text: 'Виконавець — особа, яка у відповідній зарядній сесії організовує та/або надає Користувачу Послугу заряджання під власним брендом або під брендом, доступним у Платформі, якщо інше не встановлено профілем станції.',
      },
      {
        id: '2.5',
        text: 'Власник зарядної станції — власник, орендар або інший законний користувач зарядної станції. Власник локації — власник, орендар або інший законний користувач місця, де розміщено станцію. Одна особа може одночасно виконувати кілька ролей; тоді права, обов’язки та винагороди за цими ролями підсумовуються.',
      },
      {
        id: '2.6',
        text: 'Послуга заряджання — комплексна послуга доступу до зарядної інфраструктури та заряджання акумулятора електромобіля. Обсяг послуги обліковується в кВт·год як технічний показник.',
      },
      {
        id: '2.7',
        text: 'Зарядна сесія — процес надання Послуги заряджання від старту до завершення або зупинки.',
      },
      {
        id: '2.8',
        text: 'Плата за послугу — єдина сума, яку Користувач сплачує за зарядну сесію за тарифом, показаним до старту. Вона може включати сервісну частину, технологічні витрати, комісії платіжної системи та податки, якщо вони відображені Користувачу.',
      },
    ],
  },
  {
    id: 3,
    title: header.objectAgreement,
    href: '#objectAgreement',
    texts: [
      {
        id: '3.1',
        text: 'Предмет Договору — надання Користувачу Послуги заряджання Виконавцем на зарядних станціях, підключених до Платформи 220-km.com, включно зі станціями роумінг-партнерів (зокрема EVBOOST, UGV, EVA), якщо вони доступні в інтерфейсі.',
      },
      {
        id: '3.2',
        text: 'Агрегатор забезпечує доступ до Платформи, інформації про станції та тарифи, технічний запуск сесії та інтеграцію з оплатою. Послугу заряджання надає Виконавець на конкретній станції. Оплата Користувача надходить Виконавцю; Агрегатор не є стороною цього платежу, крім випадків, коли він сам є Виконавцем на цій станції.',
      },
      {
        id: '3.3',
        text: 'Ціна Послуги вказана на 220-km.com щодо кожної станції або порту. Ціна не включає паркування чи доступ на територію, якщо власник локації встановлює таку плату окремо.',
      },
    ],
  },
  {
    id: 4,
    title: header.legalNature,
    href: '#legalNature',
    texts: [
      {
        id: '4.1',
        text: 'Користувач отримує Послугу заряджання електромобіля, а не електричну енергію як окремий товар.',
      },
      {
        id: '4.2',
        text: 'Облік у кВт·год, за часом чи потужністю потрібен лише для розрахунку вартості послуги. Це не продаж і не постачання електроенергії Користувачу.',
      },
      {
        id: '4.3',
        text: 'Відповідно до частини п’ятої статті 58 Закону України «Про ринок електричної енергії» надання послуг із заряджання електромобілів на електрозарядних станціях є споживанням електричної енергії і не є її постачанням.',
      },
    ],
  },
  {
    id: 5,
    title: header.acceptance,
    href: '#acceptance',
    texts: [
      {
        id: '5.1',
        text: 'Акцепт — будь-яка дія, що підтверджує прийняття умов: реєстрація, користування Платформою, натискання «Оплатити», «Старт», «Pay» чи аналогічної кнопки, сканування QR, підключення електромобіля до порту, початок сесії або оплата.',
      },
      {
        id: '5.2',
        text: 'Згода на отримання Послуги також виникає, якщо електромобіль фактично отримав заряд від 0,001 кВт·год. Якщо Ви не згодні з Договором — не користуйтеся Платформою і станціями.',
      },
      {
        id: '5.3',
        text: 'Підтвердженням Договору є дані Платформи, записи сесій, чеки, квитанції, платіжні повідомлення та звернення до служби підтримки.',
      },
    ],
  },
  {
    id: 6,
    title: header.payment,
    href: '#payment',
    texts: [
      {
        id: '6.1',
        text: 'Тариф показується Користувачу до початку сесії. Він може залежати від кВт·год, типу конектора, потужності, локації, часу доби, динамічного тарифу, SoC батареї чи інших параметрів, відображених у Платформі.',
      },
      {
        id: '6.2',
        text: 'Оплата здійснюється попередньо: Користувач обирає обсяг кВт·год або суму і сплачує через доступний платіжний сервіс. Окремого поповнення балансу немає — кожна сесія оплачується окремо.',
      },
      {
        id: '6.3',
        text: 'Якщо сесію перервано або фактично спожито менше, ніж оплачено, невикористаний обсяг повертається як віртуальний баланс 220-km.com і може бути використаний на наступних сесіях у мережі 220-km.com або на станціях роумінг-партнерів, доступних у Платформі.',
      },
      {
        id: '6.4',
        text: 'Доступ до зарядки надається за наявності успішної оплати або достатнього віртуального балансу. Якщо платіж відхилено, авторизацію скасовано або коштів недостатньо, Агрегатор може не запускати або зупинити сесію, якщо це технічно можливо.',
      },
      {
        id: '6.5',
        text: 'Плата за простій після зарядки не стягується.',
      },
      {
        id: '6.6',
        text: 'Оплата — у гривні, якщо в інтерфейсі не зазначено інше. Комісії банку чи платіжної системи можуть утримуватися за правилами відповідної установи.',
      },
    ],
  },
  {
    id: 7,
    title: header.refund,
    href: '#refund',
    texts: [
      {
        id: '7.1',
        text: 'Гроші за фактично надану Послугу не повертаються, крім випадків, передбачених законом, правилами платіжної системи або цим Договором.',
      },
      {
        id: '7.2',
        text: 'Якщо послугу не надано, надано не повністю або Ви оскаржуєте платіж, спочатку використайте віртуальний баланс через історію зарядок. Щоб повернути кошти на банківський рахунок після сесії з 0 кВт, натисніть кнопку «Повернення» у додатку 220 і заповніть заявку. Або напишіть у підтримку номер порту.',
      },
      {
        id: '7.3',
        text: 'Заявку розглядає Агрегатор. Строк розгляду — до 60 робочих днів залежно від банку Користувача. Агрегатор намагається опрацювати звернення швидше. Якщо повернуті кошти вже були зараховані Виконавцю, Агрегатор має право утримати цю суму з подальших розрахунків із Виконавцем.',
      },
      {
        id: '7.4',
        text: 'У заявці вкажіть телефон і причину. Сесія привʼязується автоматично за оплатою (invoice).',
      },
    ],
  },
  {
    id: 8,
    title: header.rightsAndResponsibilitySides,
    href: '#rightsAndResponsibilitySides',
    texts: [
      {
        id: '8.1',
        text: 'Користувач має право:',
        subTexts: [
          {
            id: '8.1.1',
            subText: 'бачити до старту тариф, доступність станції, мінімальну суму оплати та інші істотні умови;',
          },
          {
            id: '8.1.2',
            subText: 'отримати оплачену Послугу в межах технічних можливостей станції, електромобіля та мережі;',
          },
          {
            id: '8.1.3',
            subText: 'припинити користування Платформою в будь-який момент, якщо немає непогашеної заборгованості.',
          },
        ],
      },
      {
        id: '8.2',
        text: 'Користувач зобов’язаний:',
        subTexts: [
          {
            id: '8.2.1',
            subText: 'дотримуватися цього Договору, правил безпеки та законодавства України;',
          },
          {
            id: '8.2.2',
            subText:
              'перед зарядкою перевірити станцію, кабель, конектор і розетку автомобіля. Якщо є пошкодження, бруд або небезпека — не починати сесію і повідомити підтримку;',
          },
          {
            id: '8.2.3',
            subText: 'оплачувати Послугу лише законними платіжними засобами;',
          },
          {
            id: '8.2.4',
            subText: 'після завершення сесії від’єднати автомобіль і звільнити зарядне місце якомога швидше;',
          },
          {
            id: '8.2.5',
            subText: 'користуватися місцем для заряджання біля станції лише для електромобіля, який заряджається;',
          },
          {
            id: '8.2.6',
            subText:
              'не використовувати несправні, саморобні, несертифіковані кабелі, адаптери чи автомобілі з непередбаченими виробником змінами системи енергозабезпечення;',
          },
          {
            id: '8.2.7',
            subText:
              'не смітити і не завдавати шкоди обладнанню, програмному забезпеченню, репутації Виконавця та місцю надання Послуги;',
          },
          {
            id: '8.2.8',
            subText: 'не передавати свій доступ до Платформи іншим особам для отримання Послуги від свого імені.',
          },
        ],
      },
      {
        id: '8.3',
        text: 'Кнопка аварійної зупинки (ЕМО) призначена лише для аварійної або небезпечної ситуації. Безпідставне натискання заборонено: це зношує контактори автомобіля і станції.',
      },
      {
        id: '8.4',
        text: 'Заборонено використовувати адаптери для з’єднання зі станцією потужністю понад 80 кВт, зокрема CCS2 → NACS та CCS2 → CCS1 для американських електромобілів. Якщо після використання такого адаптера на станції понад 80 кВт виявлено несправність або пошкодження, з віртуального балансу Користувача може бути стягнуто відшкодування за відновлення або ремонт обладнання на користь Виконавця.',
      },
      {
        id: '8.5',
        text: 'Не виймайте конектор під час подачі струму. Завершуйте сесію в застосунку, через функції автомобіля або повідомте підтримку. Від’єднання під струмом може пошкодити контакти, спричинити займання або ураження струмом.',
      },
      {
        id: '8.6',
        text: 'Якщо зарядка не стартувала, станція може зберігати авторизацію короткий час для повторної спроби. Якщо повторний старт не потрібен — завершіть сесію самостійно або дочекайтеся автоматичного завершення.',
      },
    ],
  },
  {
    id: 9,
    title: header.executor,
    href: '#executor',
    texts: [
      {
        id: '9.1',
        text: 'Агрегатор забезпечує роботу Платформи, відображення тарифів і статусів станцій, технічний запуск сесії, інтеграцію з оплатою та службу підтримки в межах технічних можливостей.',
      },
      {
        id: '9.2',
        text: 'Агрегатор має право змінювати інтерфейс Платформи, перелік доступних станцій, залучати партнерів, обмежувати доступ у разі порушення Договору, шахрайства, неплатежу або небезпеки, а також публікувати нову редакцію цього Договору.',
      },
      {
        id: '9.3',
        text: 'Виконавець надає Послугу заряджання, відповідає за стан свого обладнання, монтаж, живлення та безпеку на станції, самостійно визначає тариф (у межах Платформи) і отримує оплату Користувача.',
      },
      {
        id: '9.4',
        text: 'Ані Агрегатор, ані Виконавець не продають Користувачу електроенергію як товар. Розподіл коштів між Агрегатором, Виконавцем, Власником локації та партнерами є внутрішнім і не змінює природу Послуги для Користувача.',
      },
    ],
  },
  {
    id: 10,
    title: header.liability,
    href: '#liability',
    texts: [
      {
        id: '10.1',
        text: 'Кожна сторона відповідає за свої дії в межах своєї ролі та законодавства України.',
      },
      {
        id: '10.2',
        text: 'Користувач відповідає за шкоду станції, кабелям, конекторам, локації та Платформі, завдану його діями, адаптерами, кабелями або електромобілем, а також за достовірність даних під час оплати.',
      },
      {
        id: '10.3',
        text: 'Агрегатор не відповідає за технічний стан станції Виконавця, перебої електромережі, інтернету чи банківського еквайрингу, чергу на станції, зайняте місце для заряджання, паркування, збереження автомобіля, якість зарядки через стан батареї чи BMS електромобіля, відсутність власного кабелю Користувача та наслідки використання несертифікованих адаптерів чи кабелів.',
      },
      {
        id: '10.4',
        text: 'Виконавець намагається видавати заявлену потужність, але фактична швидкість зарядки залежить від автомобіля, одночасного використання портів, мережі та погоди.',
      },
      {
        id: '10.5',
        text: 'Жодне положення не обмежує відповідальність, якщо таке обмеження заборонене законом.',
      },
    ],
  },
  {
    id: 11,
    title: header.privacy,
    href: '#privacy',
    texts: [
      {
        id: '11.1',
        text: 'Конфіденційними є платіжні дані, дані сесій, облікові ідентифікатори та персональні дані Користувача, крім інформації, яку закон дозволяє або вимагає розкривати.',
      },
      {
        id: '11.2',
        text: 'Приймаючи Договір, Користувач дає згоду на обробку персональних даних для надання Послуги, платежів, підтримки, безпеки, обліку та інформування про сервіс. Обробка здійснюється згідно із Законом України «Про захист персональних даних». Дані можуть зберігатися в Україні та за кордоном, зокрема в хмарних сервісах.',
      },
      {
        id: '11.3',
        text: 'Дані можуть бути передані банку, платіжному сервісу, Виконавцю, роумінг-партнеру, державним органам за законною вимогою, а також правонаступникам Агрегатора в разі реорганізації чи продажу бізнесу платформи.',
      },
      {
        id: '11.4',
        text: 'Користувач погоджується отримувати сервісні повідомлення (SMS, месенджери, email, дзвінки, push) щодо сесій і підтримки, а також на запис звернень до служби підтримки.',
      },
    ],
  },
  {
    id: 12,
    title: header.other,
    href: '#other',
    texts: [
      {
        id: '12.1',
        text: 'Для Користувача Договір діє з моменту акцепту, поки він користується Платформою, і до виконання зобов’язань за сесіями.',
      },
      {
        id: '12.2',
        text: 'Застосовується право України. Спори вирішуються переговорами, а якщо згоди немає — судом за законодавством України.',
      },
      {
        id: '12.3',
        text: 'Якщо окреме положення визнають недійсним, решта Договору залишається чинною.',
      },
      {
        id: '12.4',
        text: 'Користування Платформою не дає Користувачу прав на бренд, код, дизайн чи бізнес 220-km.com.',
      },
    ],
  },
];

const structureDocument = {
  header,
  introduction,
  body,
};

export default structureDocument;
